<template>
    <div class="contents">
        <div class="container-fluid">
            <BirthdayNavigation />
            <div class="row">
                <div class="col-lg-12">
                    <div class="breadcrumb-main user-member justify-content-sm-between">
                        <div class="d-flex flex-wrap justify-content-center breadcrumb-main__wrapper">
                            <div class="d-flex align-items-center user-member__title justify-content-center mr-sm-25">
                                <h4 class="text-capitalize fw-500 breadcrumb-title">
                                    Template Ucapan
                                </h4>
                            </div>
                        </div>
                        <div class="action-btn">
                            <router-link to="/birthday/template/add" style="display: inline-flex; margin: 5px">
                                <button class="btn px-15 btn-primary text-white">
                                    <i class="fas fa-plus fs-16"></i>
                                    Tambah Template
                                </button>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <div class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
                        <BirthdayTemplateTable />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BirthdayTemplateTable from "@/components/tables/BirthdayTemplate.vue";
import BirthdayNavigation from "@/components/birthday/Navigation.vue";

export default {
    components: {
        BirthdayTemplateTable,
        BirthdayNavigation
    }
};
</script>

